import React, { Component } from 'react';
import axios from 'axios'
import DefaultApp from './pages/Layout/DefaultApp';
import CS from './commons/services/Common'
import AS from './pages/Login/Service/Authentication'

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.interceptors.request.use(
  config => {
      const token = sessionStorage.getItem('token');
      if (token) {
          config.headers['Authorization'] = 'Bearer ' + token;
          config.headers['Access-Control-Allow-Origin'] = '*';
          
          /* 2024.04 */
          const kakao = sessionStorage.getItem('kakao')
          if (kakao) { 
            config.headers['Authorization'] = `KakaoAK ${process.env.REACT_APP_KAKAO_REST_API}`
            delete config.headers['Access-Control-Allow-Origin'] 
          }

      } else {
        delete config.headers['Authorization']
      }
      return config;
  },
  error => {
      Promise.reject(error)
  }
);

axios.interceptors.response.use(
    response => response,
    error => {
        if(error.response.data.status === 403) {
            AS.logout();
        }
        CS.error(error);
        return Promise.reject(error);
    }
);

class App extends Component {

    render() {
        return (
            <DefaultApp/>
        )
    }
}
export default App;
